
    import { initOnboarding } from "/js/onboarding.js";
    initOnboarding();
  